import "bootstrap/dist/css/bootstrap.min.css"
import "font-awesome/css/font-awesome.min.css"
import "./cssx/main.css"
import Modal from "./public/modal"
import Message from "./public/message"
import Login from "./public/login"
import Content from "./public/content"
import React from "react"
import Cookies from "js-cookie"
class App extends React.Component {
    constructor(props) {
        super(props)
        this.state = { ...props }
        this.state.fireBaseToken = null
        this.state.token = Cookies.get("token") //
        if (this.state.token === undefined) this.state.token = null
        this.state.month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
        this.state.googleClientId = "938856571974-294p1foob3ejpcih7bkfn8orvlgund4n.apps.googleusercontent.com"
        /*this.state.province = localStorage.getItem("province")
		if (this.state.province !== null && this.state.province !== undefined)
			this.state.province = JSON.parse(this.state.province)
		this.state.city = localStorage.getItem("city")
		if (this.state.city !== null && this.state.city !== undefined)
			this.state.city = JSON.parse(this.state.city)
		this.state.subDistrict = localStorage.getItem("subDistrict")
		if (
			this.state.subDistrict !== null &&
			this.state.subDistrict !== undefined
		)
			this.state.subDistrict = JSON.parse(this.state.subDistrict)*/
    }
    componentDidMount() {}
    post = (e) => {
        if (e.key === undefined) e.key = new Date().getTime()
        if (e.success === undefined) e.success = this.success
        if (e.warning === undefined) e.warning = this.warning
        if (e.error === undefined) e.error = this.error
        this.setState({ post: e })
    }
    error = (e) => {
        if (typeof e === "string") e = { message: e }
        if (typeof e.message !== "object") e.message = (isNaN(e.code) ? "" : e.code + " - ") + e.message
        if (e.message.split("401").length <= 1) this.message({ mode: "danger", message: e.message })
    }
    warning = (e) => {
        if (typeof e === "string") e = { message: e }
        e.code = isNaN(e.code) ? 400 : e.code * 1
        if (e.code * 1 === 401 || e.code * 1 === 402) this.logOut({ force: true })
        e.withLine = e.message.split("<br>").join("<br />").split("<br/>").join("<br />").split("<br />")
        if (e.withLine.length > 1) {
            e.message = e.withLine.map((expr) => {
                return <div>{expr}</div>
            })
        }
        this.message({ mode: "warning", message: e.message })
        return e
    }
    success = (e) => {
        if (typeof e === "string") e = { message: e }
        this.message({ mode: "success", message: e.message })
    }
    message = (e) => {
        this.setState({
            message: {
                key: new Date().getTime(),
                mode: e.mode === undefined ? "info" : e.mode,
                children: e.message
            }
        })
    }
    modal = (e) => {
        if (e.key === undefined) e.key = new Date().getTime()
        this.setState({ modal: e })
        return e.key
    }
    dmy = (e, x) => {
        if (typeof e === "string") e = new Date(e)
        x = {
            month: this.state.month[e.getMonth()].substr(0, 3),
            year: e.getFullYear(),
            day: e.getDate()
        }
        if (x.day < 10) x.day = "0" + x.day
        return x.day + " " + x.month + " " + x.year
    }
    logOut = (e) => {
        if (typeof e !== "object") e = { force: false }
        else if (e.force === undefined) e.force = false
        if (!e.force)
            this.post({
                url: "logout",
                token: Cookies.get("token"),
                success: (e) => {
                    this.success(e.message)
                }
            })
        Cookies.remove("user")
        Cookies.remove("token")
        Cookies.remove("isLoggedIn")
        Cookies.remove("menu")

        localStorage.removeItem("province")
        localStorage.removeItem("city")
        localStorage.removeItem("subDistrict")
        this.setState({ token: null })
        window.location.reload()
    }
    logIn = (e) => {
        Cookies.set("user", JSON.stringify(e.user))
        Cookies.set("token", e.token)
        Cookies.set("isLoggedIn", "true")

        localStorage.setItem("province", JSON.stringify(e.province))
        localStorage.setItem("city", JSON.stringify(e.city))
        localStorage.setItem("subDistrict", JSON.stringify(e.subDistrict))
        this.setState(e)
        //window.location.reload();
    }
    closeModal = (e) => {
        if (this.state.modal !== undefined) if (this.state.modal.closeModal !== undefined) this.state.modal.closeModal()
        this.setState({ modal: undefined })
    }
    render(loading) {
        // loading = window.loading()
        // setTimeout(() => loading.hide(), 500)
        return (
            <>
                {this.RenderLoginOrContent()}
                {this.RenderModal()}
                {this.RenderPostModal()}
                {this.RenderMessage()}
            </>
        )
    }
    RenderLoginOrContent = (e) => {
        e = {
            fn: {
                post: this.post,
                error: this.error,
                warning: this.warning,
                success: this.success,
                message: this.message,
                modal: this.modal,
                dmy: this.dmy,
                logOut: this.logOut,
                logIn: this.logIn,
                closeModal: this.closeModal
            },
            app: {
                tokenStorageName: "token",
                themeStorageName: "theme",
                month: this.state.month,
                fireBaseToken: this.state.fireBaseToken,
                googleClientId: this.state.googleClientId,
                province: this.state.province,
                city: this.state.city,
                subDistrict: this.state.subDistrict
            }
        }
        return this.state.token === null ? <Login fn={e.fn} app={e.app} /> : <Content fn={e.fn} app={e.app} />
    }
    RenderModal = () => {
        return this.state.modal !== undefined ? (
            <Modal
                loading={false}
                key={this.state.modal.key}
                token={this.state.token}
                title={this.state.modal.title}
                width={this.state.modal.width}
                height={this.state.modal.height}
                backgroundColor={this.state.modal.backgroundColor}
                backgroundStyle={this.state.modal.backgroundStyle}
                closeModal={this.closeModal}
            >
                {this.state.modal.children !== undefined ? this.state.modal.children : this.state.modal.text}
            </Modal>
        ) : (
            <></>
        )
    }
    RenderPostModal = () => {
        return this.state.post !== undefined ? (
            <Modal
                post={this.state.post}
                key={this.state.post.key}
                token={this.state.post.token === undefined ? this.state.token : this.state.post.token}
                closeModal={() => {
                    this.setState({ post: undefined })
                }}
            />
        ) : (
            <></>
        )
    }
    RenderMessage = () => {
        return this.state.message !== undefined ? (
            <Message
                mode={this.state.message.mode}
                key={this.state.message.key}
                closeMessage={() => {
                    this.setState({ message: undefined })
                }}
            >
                {this.state.message.children !== undefined ? this.state.message.children : this.state.message.text}
            </Message>
        ) : (
            <></>
        )
    }
}
export default App
